import { createAsyncThunk } from "@reduxjs/toolkit";
import { useHttp } from "../hooks/use-http";
import axios from "axios";
import { API_URL } from "../config/config";

const getCorDocs = createAsyncThunk("corDocs/getAll", async ({ direction }) => {
  const { request } = useHttp();
  return await request({
    url: `/cor_management/cor_man_docs_list/?direction=${direction}`,
  });
});

const getLinksToCorDocs = async ({ direction }) => {
  try {
    const response = await axios.get(
      `${API_URL}/cor_management/cor_man_docs/?direction=${direction}`,
      {
        headers: {
          "ngrok-skip-browser-warning": "any",
        },
      }
    );

    // Check for success status
    if (response.status !== 200) {
      throw new Error(`Error: ${response.status}`);
    }

    return response.data;
  } catch (error) {
    console.error("Failed to fetch documents:", error);
    // You can rethrow the error if you want to handle it in your query
    throw error;
  }
};

export { getCorDocs, getLinksToCorDocs };
